<template>
  <el-popover v-if="isCatProp" trigger="focus" placement="top" :disabled="!hasTips">
    <span style="display: block" v-for="(tip, tipIndex) in tips" v-html="tip" :key="tipIndex"></span>
    <el-input slot="reference" v-bind="props" :value="_value" @input="onInput" @blur="onBlur" class="input-box">
      <template v-if="maxLengthRule" slot="append">{{ inputLength }}/{{ maxLengthRule }}</template>
    </el-input>
  </el-popover>
  <el-input v-else v-bind="props" :value="_value" @input="onInput" @blur="onBlur" class="input-box">
    <template v-if="props.append" slot="append">{{ props.append }}</template>
    <template v-if="maxLengthRule" slot="append">{{ inputLength }}/{{ maxLengthRule }}</template>
  </el-input>
</template>

<script>
import { checkLength } from '../../utils/index';
import storeMixins from '../store-mixins';
export default {
  mixins: [storeMixins],
  props: ['props', 'tipRule', 'value', 'isMultiComlexItem', 'emitUpdate'],
  computed: {
    key() {
      return this.props.name;
    },
    tips() {
      return this.tipRule || [];
    },
    hasTips() {
      return this.tips.length;
    },
    isCatProp() {
      return this.props.parentName === 'catProp';
    },
    _value() {
      if (this.isMultiComlexItem || this.emitUpdate) {
        return this.value;
      }
      return this.alibabaForm[this.key];
    },
    _oriRules() {
      return this.props.dataSource._oriRules || {};
    },
    maxLengthRule() {
      return Number(this._oriRules?.maxLengthRule || 0);
    },
    inputLength() {
      const value = this._value || '';
      return this._oriRules.unit === 'byte' ? checkLength(value) : value.length;
    },
  },
  methods: {
    onInput(v) {
      if (this.isMultiComlexItem) {
        return this.$emit('change', v);
      }
      const newFormFields = {};
      newFormFields[this.key] = v;
      this.updateForm(newFormFields);
    },
    onBlur(v) {
      this.$emit('blur', v, this.key);
    },
    updateForm(valueObj) {
      if (this.emitUpdate) {
        this.$emit('change', valueObj);
      } else {
        this.updateAlibabaForm(valueObj);
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.input-box {
  ::v-deep .el-input-group__append {
    padding: 0 5px;
  }
}
</style>